String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1)
}
String.prototype.firstLetterToUpperCase = function () {
  return this[0].toUpperCase() + this.slice(1)
}
String.prototype.firstLetterToLowerCase = function () {
  return this[0].toLowerCase() + this.slice(1)
}
